import { jsx, css } from '@emotion/react';
import { define, ui } from '@owenscorning/pcb.alpha';

import Renderer from '../../../../OC/PageBuilder/PersonalInformationTable.jsx';

export default define`Personal Information Table`('0.0.1')({
  thumbnail: ui`Modules/Page/Thumbnails/PersonalInformationTable`,
  category: ui`Modules/Categories/Page/Prebuilt`,
  view: ({ value }) => <Renderer {...value} />,
  edit: {},
});
